module.exports = __webpack_public_path__ + "static/img/1431335355535.243db01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1431335355535.jpg
// module id = e2Om
// module chunks = 1